export default "<!-- Scroll to top functionality -->\n<app-scroll-top></app-scroll-top>\n<!-- <app-loading></app-loading> -->\n<router-outlet></router-outlet>";